/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

// component
import Whatsapp from "../../components/whatsapp/whatsapp";

// styling
import style from "./footer.module.scss";

// external package
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";

export default function Footer() {
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);

  return (
    <>
      <div className={`footer-content ${isMobile ? "" : "pt-5 mt-5"}`}>
        <div
          className={`footer-content_focus ${
            isMobile ? "row" : "px-5  d-flex justify-content-between"
          }`}
        >
          <div
            className={`footer-content_focus_menu ${isMobile ? "col-12" : ""}`}
          >
            <p
              className={`${
                isMobile ? "font-size-18 mb-0" : "font-size-28"
              } text-uppercase fw-bold`}
            >
              <a href="/about" className="" rel="noreferrer">
                about
              </a>
            </p>
            <p
              className={`${
                isMobile ? "font-size-18 mb-0" : "font-size-28"
              } text-uppercase fw-bold`}
            >
              <a href="/services" className="">
                service
              </a>
            </p>
            <p
              className={`${
                isMobile ? "font-size-18 mb-0" : "font-size-28"
              } text-uppercase fw-bold`}
            >
              <a href="#" className="">
                portofolio
              </a>
            </p>
            <p
              className={`${
                isMobile ? "font-size-18 mb-0" : "font-size-28"
              } text-uppercase fw-bold`}
            >
              <a href="/contact" className="">
                contact us
              </a>
            </p>
          </div>
          <div
            className={`footer-content_direct_email  ${
              isMobile ? "col-12 py-4" : "w-25"
            }`}
          >
            <span className="font-size-18 font-vietnam-200 text-data">
              receive valuable industry insight & if you have any questions feel
              free to contact us{" "}
            </span>
            <div className="input-group mb-3 mt-2">
              <input
                className="input-bale form-control form-control-lg"
                type="text"
                placeholder="Enter Your Email"
              />
              <span className="input-group-text input-bale-group">
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </div>
          </div>
        </div>
        <h1
          className={`font-federicka text-center mt-5 text-uppercase ${
            isMobile ? "font-size-36" : "font-size-160"
          }`}
        >
          bale's
        </h1>
        <div className="footer-content_bar">
          <nav
            className={`navbar navbar-expand-lg navbar-light bg-white-8 py-2${style.border_bottom_navbar}`}
          >
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav mb-2 mx-auto mb-lg-0">
                <li
                  className={`nav-item ${style.nav_distance} font-vietnam-400`}
                >
                  <a
                    className="nav-link font-vietnam-600 text-capitalize font-size-18"
                    target="_blank"
                    href="https://www.linkedin.com/in/muhammad-iqbal-aulia-rafi"
                    rel="noreferrer"
                  >
                    LinkedIn
                  </a>
                </li>
                <li
                  className={`nav-item ${style.nav_distance} font-vietnam-400`}
                >
                  <a
                    className="nav-link"
                    href="https://www.linkedin.com/in/muhammad-iqbal-aulia-rafi"
                  >
                    Copyright ©{" "}
                    <span className="font-vietnam-400-italic text-capitalize font-size-18">
                      Iqbal Aulia
                    </span>
                  </a>
                </li>
                <li
                  className={`nav-item ${style.nav_distance} font-vietnam-400`}
                >
                  <a
                    className="nav-link font-vietnam-600 text-capitalize font-size-18"
                    target="_blank"
                    href="https://github.com/Iqbalaulia"
                    rel="noreferrer"
                  >
                    Github
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
      <Whatsapp />
    </>
  );
}
